import axios from "axios";
// import * as URL from "../../helpers/Constants";

const DUMMY_ADDITIONAL_BALANCES = {
    content: [
        {
            id: "ab001",
            balanceDate: "03-08-2025 00:00:00",
            amount: 200,
            note: "Note: All records clear",
            lastModifiedDate: "03-08-2025 04:35:00",
            lastModifiedBy: {fullName: "Abid Shinepuk"},
        },
        {
            id: "ab002",
            balanceDate: "03-08-2025 00:00:00",
            amount: 100,
            note: "Note: All records clear",
            lastModifiedDate: "03-08-2025 04:35:00",
            lastModifiedBy: {fullName: "Abid Shinepuk"},
        },
        {
            id: "ab003",
            balanceDate: "03-08-2025 00:00:00",
            amount: 150,
            note: "Note: All records clear",
            lastModifiedDate: "03-08-2025 04:35:00",
            lastModifiedBy: {fullName: "Abid Shinepuk"},
        },
        {
            id: "ab004",
            balanceDate: "03-08-2025 00:00:00",
            amount: 181,
            note: "Note: All records clear",
            lastModifiedDate: "03-08-2025 04:35:00",
            lastModifiedBy: {fullName: "Abid Shinepuk"},
        },
        {
            id: "ab005",
            balanceDate: "03-08-2025 00:00:00",
            amount: 150,
            note: "Note: All records clear",
            lastModifiedDate: "03-08-2025 04:35:00",
            lastModifiedBy: {fullName: "Abid Shinepuk"},
        },
    ],
    totalElements: 5,
    totalAmount: 781,
    totalPages: 1,
    first: true,
    last: true,
    size: 10,
    number: 0,
    numberOfElements: 5,
    empty: false,
};

export default class PMSAdditionalBalanceServices {

    static getAllAdditionalBalancesByPharmacyId(params) {
        // return axios.get(`${URL.PMS_GET_ALL_ADDITIONAL_BALANCE_BY_PHARMACY_ID}/${params.pharmacyId}`, {
        //     ...PMSAdditionalBalanceServices.getAuthHeader(), params,
        // });
        return Promise.resolve({data: DUMMY_ADDITIONAL_BALANCES});
    }

    static createAdditionalBalance(pharmacyId, data) {
        // return axios.post(`${URL.PMS_CREATE_ADDITIONAL_BALANCE}/${pharmacyId}`, data,
        //     PMSAdditionalBalanceServices.getAuthHeader()
        // );
        return Promise.resolve({data: {id: `ab_${Date.now()}`, ...data}});
    }

    static updateAdditionalBalance(id, pharmacyId, data) {
        // return axios.put(`${URL.PMS_UPDATE_ADDITIONAL_BALANCE}/${id}/${pharmacyId}`, data,
        //     PMSAdditionalBalanceServices.getAuthHeader()
        // );
        return Promise.resolve({data: {id, ...data}});
    }

    static deleteAdditionalBalance(id, pharmacyId) {
        // return axios.post(`${URL.PMS_DELETE_ADDITIONAL_BALANCE}/${id}/${pharmacyId}`, {},
        //     PMSAdditionalBalanceServices.getAuthHeader()
        // );
        return Promise.resolve({data: true});
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        };
    }
}
